/**
 * Expanded detail panel for a single log entry.
 */
import type { SessionLogEntry } from "@memes/shared";
import { formatLogSummary } from "../../lib/logFormat";

export function LogEntryDetail({
  entry,
  onClose,
}: {
  entry: SessionLogEntry;
  onClose: () => void;
}): React.ReactElement {
  const copy = async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(JSON.stringify(entry, null, 2));
    } catch {
      /* ignore */
    }
  };

  return (
    <div className="border-t border-indigo-200 bg-indigo-50/80 dark:border-indigo-900 dark:bg-indigo-950/40">
      <div className="flex flex-wrap items-center justify-between gap-2 border-b border-indigo-100 px-3 py-2 dark:border-indigo-900">
        <div className="min-w-0 text-sm">
          <span className="font-medium text-gray-800 dark:text-gray-100">
            {formatLogSummary(entry)}
          </span>
          <span className="ml-2 text-xs text-gray-500">{entry.ts}</span>
        </div>
        <div className="flex shrink-0 gap-2">
          <button type="button" className="btn text-xs" onClick={() => void copy()}>
            Copy JSON
          </button>
          <button type="button" className="btn text-xs" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
      <pre className="max-h-64 overflow-auto p-3 font-mono text-[11px] leading-relaxed text-gray-800 dark:text-gray-200">
        {JSON.stringify(entry, null, 2)}
      </pre>
    </div>
  );
}
